module.exports = __webpack_public_path__ + "img/sharpen-before.e891360a.webp";